import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const lowerParel: AreaConfig = {
  name: 'Lower Parel',
  slug: 'lower-parel',
  tagline: 'Doorstep Mobile Repair in Lower Parel, Mumbai',
  description:
    "Mumbai's corporate and lifestyle hub gets doorstep phone repair. Minto's technician visits your office at Kamala Mills, Phoenix, or your home in Worli — screen, battery, or any repair in under an hour.",
  localities: [
    'Lower Parel', 'Prabhadevi', 'Worli', 'Parel', 'Elphinstone Road',
    'Kamala Mills', 'Phoenix Market City', 'Currey Road', 'Byculla', 'Jacob Circle',
    'Lalbaug', 'Chinchpokli', 'Mahalaxmi',
  ],
  zones: [
    {
      name: 'Lower Parel — Kamala Mills & Phoenix',
      line: 'Western Line',
      station: 'Lower Parel Station',
      localities: ['Kamala Mills', 'High Street Phoenix', 'Peninsula Corporate Park', 'Indiabulls Finance Centre', 'One Indiabulls', 'Spring Mills'],
      desc: "Lower Parel's office towers and malls fully covered. Our technicians visit corporate campuses — repair done at your desk while you work.",
    },
    {
      name: 'Elphinstone Road & Prabhadevi',
      line: 'Western Line',
      station: 'Elphinstone Road Station (Prabhadevi)',
      localities: ['Prabhadevi', 'Elphinstone Road', 'Century Mills', 'Worli Naka', 'Dr. Annie Besant Road'],
      desc: 'Prabhadevi and the area around Elphinstone Road station covered for both home and office doorstep repairs.',
    },
    {
      name: 'Parel, Currey Road & Mahalaxmi',
      line: 'Central Line',
      station: 'Currey Road Station / Mahalaxmi Station',
      localities: ['Parel', 'Currey Road', 'Lalbaug', 'Chinchpokli', 'Jacob Circle', 'Byculla', 'Mahalaxmi'],
      desc: 'Covering the Central line belt from Currey Road to Mahalaxmi. Same-day doorstep repair for residents and offices.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Lower Parel | Doorstep Phone Repair | Minto',
    description:
      'Doorstep mobile repair in Lower Parel, Parel, Worli, Prabhadevi & Mahalaxmi, Mumbai. Screen, battery & charging port repair. Certified technicians, 90-day warranty. Book now!',
    keywords:
      'mobile repair Lower Parel, phone repair Lower Parel, screen repair Lower Parel, battery replacement Lower Parel, iPhone repair Lower Parel, Samsung repair Lower Parel, mobile repair Parel, phone repair Worli, mobile repair Prabhadevi, Kamala Mills phone repair, doorstep repair Lower Parel',
  },
  faqs: [
    {
      q: 'Can you repair my phone at my office in Kamala Mills or Phoenix?',
      a: 'Yes! We regularly service offices in Kamala Mills, Phoenix, Peninsula Park, and Indiabulls. Book a slot and our technician visits your desk.',
    },
    {
      q: 'Do you cover residential buildings in Lower Parel?',
      a: "Yes, we cover all residential towers and societies in Lower Parel, Worli, and Prabhadevi.",
    },
    {
      q: 'How fast is the response in Lower Parel?',
      a: 'Typically 60–90 minutes from booking. Lower Parel is one of our high-demand zones with technicians available throughout the day.',
    },
    {
      q: 'Do you also serve Mahalaxmi and Byculla near Lower Parel?',
      a: 'Yes, Mahalaxmi, Currey Road, Lalbaug, and Byculla are all within our Lower Parel service area.',
    },
    {
      q: 'What is the warranty on repairs in Lower Parel?',
      a: 'All repairs come with a 90-day warranty. Screen and battery replacements are also covered under this warranty.',
    },
  ],
};

const LowerParelPage: React.FC = () => <AreaLandingPage area={lowerParel} />;
export default LowerParelPage;
